import request from "../plugins/axios";

export function userLogin(data) {
	return request({
		url: '/login/index',
        method: 'POST',
        data
	})
}

export function blackRoomList(params) {
	return request({
		url: '/scrm/BlackRoomList',
		method: 'GET',
		params
	})
}

export function pendingReviewList(params) {
	return request({
		url: '/scrm/GetRepeatList',
		method: 'GET',
		params
	})
}

export function disableContact(data) {
	return request({
		url: '/scrm/DisableContact',
		method: 'POST',
		data
	})
}
export function userRegister(data) {
	return request({
		url: '/scrm/tenantRegisterAudit',
		method: 'POST',
		data
	})
}
